import React from 'react';
import Home from '../home';

function HomePage() {
    return (
        <Home />
    )
}

export default HomePage;